import domain from './domain';
import cookieConfig from './cookie';
import sessionConfig from './session';
import loginEndpointsConfig from './loginEndpoints';
import recaptchaConfig from './recaptcha';
import searchEngineConfig from './searchEngine';
import gaConfig from './ga';
import socketConfig from './socket';
import assetsConfig from './assets';

const config = {
  host: domain.finsightDomain,
  ...domain,
  assets: assetsConfig,
  session: sessionConfig,
  cookie: cookieConfig,
  ga: gaConfig,
  socket: socketConfig,
  loginEndpoints: loginEndpointsConfig,
  recaptcha: recaptchaConfig,
  searchEngine: searchEngineConfig,
};

export default config;
